<template>
    <div
        v-if="visible"
        class="acciones-seleccion ayuda-seleccion-fija"
        :class="{ 'ayuda-seleccion-sobre-footer': ayudaSeleccionSobreFooter }"
        role="status"
    >
        <span class="ayuda-seleccion-icono" aria-hidden="true">
            <svg viewBox="0 0 24 24">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h8.7a2 2 0 0 0 2-1.6L22 6H6"></path>
            </svg>
        </span>
        <span class="ayuda-seleccion-texto">
            {{ texto }}
        </span>
        <button
            type="button"
            class="btn-close"
            aria-label="Cerrar"
            @click="cerrar"
        ></button>
    </div>
</template>

<script>
export default {
    name: "AyudaSeleccion",
    emits: ["visible-change"],
    props: {
        texto: {
            type: String,
            required: true,
        },
        cookieName: {
            type: String,
            required: true,
        },
    },
    data(){
        return {
            visible: false,
            ayudaSeleccionSobreFooter: false,
        }
    },
    mounted(){
        this.visible = !this.obtenerCookie(this.cookieName);
        this.$emit("visible-change", this.visible);
        this.actualizarPosicion();
        window.addEventListener("scroll", this.actualizarPosicion, { passive: true });
        window.addEventListener("resize", this.actualizarPosicion);
    },
    beforeUnmount(){
        window.removeEventListener("scroll", this.actualizarPosicion);
        window.removeEventListener("resize", this.actualizarPosicion);
    },
    methods: {
        actualizarPosicion(){
            const footer = document.querySelector(".site-footer");

            if(!footer){
                this.ayudaSeleccionSobreFooter = false;
                return;
            }

            const espacioInferior = 12;
            const footerTop = footer.getBoundingClientRect().top;
            this.ayudaSeleccionSobreFooter = footerTop <= window.innerHeight - espacioInferior;
        },
        cerrar(){
            this.visible = false;
            document.cookie = `${this.cookieName}=1; max-age=2592000; path=/; SameSite=Lax`;
            this.$emit("visible-change", false);
        },
        obtenerCookie(nombreCookie){
            const nombre = nombreCookie + "=";
            const cookies = document.cookie.split(";");

            for(let i = 0; i < cookies.length; i++){
                let cookie = cookies[i].trim();

                if(cookie.indexOf(nombre) === 0){
                    return cookie.substring(nombre.length, cookie.length);
                }
            }

            return "";
        },
    }
}
</script>

<style lang="scss" scoped>
    @use "sass:math";

    @function pxToRem($value) {
        $remValue: math.div($value, 16) + rem;
        @return $remValue;
    }

    .acciones-seleccion.ayuda-seleccion-fija{
        align-items: center;
        background: #0b94cf;
        border: 1px solid #0b94cf;
        border-radius: pxToRem(8);
        bottom: pxToRem(12);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
        color: #fff;
        display: flex;
        flex-wrap: nowrap;
        font-size: pxToRem(14);
        gap: pxToRem(6);
        justify-content: center;
        left: pxToRem(10);
        line-height: 1.25;
        margin: 0;
        min-height: pxToRem(64);
        padding: pxToRem(8) pxToRem(50) pxToRem(8) pxToRem(14);
        position: fixed;
        right: pxToRem(10);
        text-align: center;
        z-index: 999;

        &.ayuda-seleccion-sobre-footer{
            bottom: pxToRem(12);
            position: absolute;
        }

        .ayuda-seleccion-icono{
            align-items: center;
            background: #000;
            border-radius: 50%;
            color: #fff;
            display: inline-flex;
            flex: 0 0 pxToRem(38);
            height: pxToRem(38);
            justify-content: center;
            width: pxToRem(38);

            svg{
                fill: none;
                height: pxToRem(22);
                stroke: currentColor;
                stroke-linecap: round;
                stroke-linejoin: round;
                stroke-width: 2;
                width: pxToRem(22);
            }
        }

        .ayuda-seleccion-texto{
            color: #fff;
            flex: 1 1 auto;
            font-weight: 500;
            max-width: 680px;
            min-width: 0;
            padding-right: pxToRem(8);
            text-align: left;
        }

        .btn-close{
            background-color: #000;
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707A1 1 0 0 1 .293.293z'/%3e%3c/svg%3e");
            background-size: pxToRem(12);
            filter: none;
            gap: 0;
            height: pxToRem(24);
            margin: 0;
            opacity: 1;
            padding: pxToRem(6);
            position: absolute;
            right: pxToRem(8);
            top: 50%;
            transform: translateY(-50%);
            width: pxToRem(24);
        }

        @media (min-width: 767px){
            font-size: pxToRem(16);
            left: 50%;
            max-width: 760px;
            padding: pxToRem(8) pxToRem(50) pxToRem(8) pxToRem(18);
            right: auto;
            transform: translateX(-50%);
            width: calc(100% - #{pxToRem(32)});

            .ayuda-seleccion-icono{
                flex-basis: pxToRem(42);
                height: pxToRem(42);
                width: pxToRem(42);
            }

            .ayuda-seleccion-texto{
                max-width: 680px;
                padding-right: pxToRem(12);
                text-align: center;
            }

            .btn-close{
                height: pxToRem(28);
                right: pxToRem(12);
                width: pxToRem(28);
            }
        }
    }
</style>
